var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { class: _vm.optionClass, on: { click: _vm.handleClick } },
    [
      _c("div", { staticClass: "config-option__top" }, [
        _c("div", { staticClass: "config-option__header" }, [
          _c("h1", { staticClass: "config-option__title title-6" }, [
            _vm._v(_vm._s(_vm.option.name))
          ]),
          _vm._v(" "),
          _c("h2", { staticClass: "config-option__price" }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.price) } }),
            _vm._v(" "),
            _vm.counter > 1 && _vm.isActive
              ? _c("span", { staticClass: "config-option__total" }, [
                  _vm._v(
                    _vm._s(_vm.option.price * _vm.counter) +
                      " zł (koszt całkowity) "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "config-option__content",
            domProps: { innerHTML: _vm._s(_vm.option.description) }
          }),
          _vm._v(" "),
          _vm.isActive && this.option.max > 1
            ? _c("div", { staticClass: "config-option__counter counter" }, [
                _c(
                  "div",
                  {
                    staticClass: "counter__button counter__button--minus",
                    on: {
                      click: function($event) {
                        if ($event.target !== $event.currentTarget) {
                          return null
                        }
                        $event.stopPropagation()
                        return _vm.decreaseCounter($event)
                      }
                    }
                  },
                  [_vm._v("\n          -\n        ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "counter__max" }, [
                  _vm._v("\n          " + _vm._s(_vm.counter) + "\n        ")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "counter__button counter__button--add",
                    on: {
                      click: function($event) {
                        if ($event.target !== $event.currentTarget) {
                          return null
                        }
                        $event.stopPropagation()
                        return _vm.increaseCounter($event)
                      }
                    }
                  },
                  [_vm._v("\n          +\n        ")]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "config-option__marker" }, [
          _vm.isActive
            ? _c(
                "svg",
                {
                  staticClass: "feather feather-check",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "#55576C",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                },
                [_c("polyline", { attrs: { points: "20 6 9 17 4 12" } })]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "config-option__image" }, [
        _c("img", { attrs: { src: _vm.option.image, alt: "" } })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-200ec6a6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/mrkaluzny/Developer/tarasy-nad-stawem/web/app/themes/tarasy-nad-stawem/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-200ec6a6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!/Users/mrkaluzny/Developer/tarasy-nad-stawem/web/app/themes/tarasy-nad-stawem/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/partials/ConfigOption.vue
// module id = 88
// module chunks = 0